import React from 'react';
import { Line, Pie } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  ArcElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  ArcElement,
  Title,
  Tooltip,
  Legend
);

const DashboardChart = ({ type, title, data, options, height, x_title, y_title }) => {
  // Default chart options for Chart.js v3
  const defaultOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      title: {
        display: true,
        text: title || ''
      },
      legend: {
        display: type === 'pie',
        position: 'bottom'
      },
    },
    scales: type !== 'pie' ? {
      x: {
        grid: {
          display: false
        },
        title: {
          display: true,
          text: x_title || ''
        },
        ticks: {
          font: {
            size: 8
          }
        }
      },
      y: {
        grid: {
          display: false
        },
        title: {
          display: true,
          text: y_title || ''
        },
        ticks: {
          beginAtZero: true
        }
      }
    } : {}
  };

  const mergedOptions = { ...defaultOptions, ...(options || {}) };

  return (
    <div style={{ height: height || '250px', width: '100%' }}>
      {type === 'line' && <Line data={data} options={mergedOptions} />}
      {type === 'pie' && <Pie data={data} options={mergedOptions} />}
    </div>
  );
};

export default DashboardChart;
